module.exports = __webpack_public_path__ + "static/img/govInfoBg.9a90503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/govInfoBg.png
// module id = FEg6
// module chunks = 2